import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchRSVPLinkSync } from '@/store/slices/integrations';
import { getWorkingProjectUuid } from '@/store/slices/project/selectors';
import { useEffect, useRef } from 'react';

const useLoadRSVPLinkSync = () => {
  const workingProjectUuid = useAppSelector(getWorkingProjectUuid);

  const dispatch = useAppDispatch();

  const fetched = useRef(false);

  useEffect(() => {
    if (fetched.current || !workingProjectUuid) return;
    fetched.current = true;
    dispatch(fetchRSVPLinkSync({ workingProjectUuid }));
  }, [dispatch, workingProjectUuid]);
};

export default useLoadRSVPLinkSync;
